<template>
  <div class="sy-text-area" :class="{
      'sy-text-area-mini': size === 'mini',
      'sy-text-area-small': size === 'small' || !size
    }">
    <el-input
      v-on="$listeners"
      type="textarea"
      v-bind="{...$props}"
      resize="vertical"
      :value="value"
      @blur="handleBlur"
      @input="handleInput"
    />
    <span class="input-len" v-if="showLength"><span class="current-len">{{inputLen}}</span>/{{maxLength}}</span>
  </div>
</template>

<script>
  import {textAreaProps} from '../index'

  export default {
    name: 'edit-text-area',
    props: textAreaProps,
    model: {
      prop: 'value',
      event: 'change'
    },
    computed: {
      inputLen () {
        return this.value ? this.value.length : 0
      }
    },
    methods: {
      handleInput (value) {
        this.$emit('change', value)
      },
      handleBlur (e) {
        this.$emit('change', e.target.value.replace(/^\s+|\s+$/g, ''))
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sy-text-area {
    position: relative;

    ::v-deep .el-textarea textarea {
      resize: vertical !important;
      max-height: 120px;
      line-height: 20px;
    }

    ::v-deep textarea:-ms-input-placeholder {
      /* Internet Explorer 10+ */
      color: #bbb !important;
    }

    .input-len {
      position: absolute;
      right: 0;
      bottom: -20px;
      font-size: 12px;

      .current-len {
        color: #999;
      }
    }
  }

  .sy-text-area-mini {
    ::v-deep .el-textarea textarea {
      height: 28px;
    }
  }

  .sy-text-area-small {
    ::v-deep .el-textarea textarea {
      height: 32px;
    }
  }

  .el-textarea__inner {
    color: #303030 !important;
  }
</style>
